import { Button, Col, Form, Modal, Row } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import FormItem from '../common/FormItem/FormItem';

const Profile = ({
  isLoading = false,
  onSubmit,
  profile,
  okText = 'Save',
  closable = true,
  cancelText = 'Cancel',
  onCancel = () => {},
}) => {
  const { t } = useTranslation('Vindoc');

  const [form] = Form.useForm();

  const actionSave = () => {
    form
      .validateFields()
      .then((values) => {
        onSubmit(values);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    form.setFieldsValue(profile);
  }, [profile]);

  return (
    <Modal
      open={true}
      maskClosable={false}
      closable={closable}
      onCancel={onCancel}
      centered
      forceRender
      footer={null}
      title={t('Update Profile')}
      width={800}
      confirmLoading={isLoading}
    >
      <Form form={form} onFinish={actionSave} layout="vertical" name="edit-account">
        <Row gutter={32}>
          <Col xs={24} xl={12}>
            <FormItem.Input
              name="fullname"
              label={t('Full Name')}
              placeholder={t('Enter Full Name')}
              required
            />

            <FormItem.Input
              name="title"
              label="Academic Rank/Degree"
              placeholder={t('Enter Academic Rank/Degree')}
              // required
            />

            <FormItem.Department name="department_id" keyValue="id" label={t('Department_Title')} />

            <Row gutter={16}>
              <Col xs={24} sm={12}>
                <FormItem.Gender />
              </Col>
              <Col xs={24} sm={12}>
                <FormItem.Birthday />
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} sm={12}>
                <FormItem.Username disabled />
              </Col>
              <Col xs={24} sm={12}>
                <FormItem.Input name="his_id" label={t('HIS ID')} placeholder={t('Enter HIS ID')} />
              </Col>
            </Row>
          </Col>

          <Col xs={24} xl={12}>
            <FormItem.Email disabled={profile?.email == profile?.username} />
            <FormItem.PhoneNumber />
            <FormItem.Input name="address" label={t('Address')} placeholder={t('Enter Address')} />
            <FormItem.Upload
              name="signature"
              label={t('Signature')}
              placeholder={t('Upload Signature')}
              form={form}
              editItem={profile}
              setEditItem={(val) => form.setFieldValue('signature', val)}
            />
          </Col>
        </Row>
      </Form>
      <div className="footer mt-3 flex justify-end">
        {closable && (
          <Button className="mr-2" onClick={onCancel}>
            {t(cancelText)}
          </Button>
        )}
        <Button type="primary" onClick={actionSave}>
          {t(okText)}
        </Button>
      </div>
    </Modal>
  );
};

export default Profile;
